<template src="./vehicleinspectionedit.html"></template>
<script>
  import VehicleInspectionForm from "@/pages/vehicleinspections/vehicleinspectionform/vehicleinspectionform";
  export default {
    components: {
      VehicleInspectionForm,
    },
    data() {
      return {
        UniqueId: "",
        InspectionId: 0,
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicle Inspection";
      this.UniqueId = this.$route.params.UniqueId;
      this.InspectionId = this.$route.params.InspectionId;
    },
  };
</script>
